<template>
  <div class="overlay">
    <div class="modal-wrapper p-4 bg-white rounded shadow">
      <portlet :actionsBlock="true">
        <template #portletBody>
          <div class="container">
            <div class="row">
              <div class="col-md-4">
                <div
                  class="d-flex justify-content-between align-items-center mb-2 p-3 bg-light"
                >
                  <span class="font-weight-bold">Select all team</span>
                  <input
                    type="checkbox"
                    v-model="selectAll"
                    @change="toggleSelectAll"
                  />
                </div>
                <div class="user-list rounded p-2">
                  <div
                    v-for="user in users"
                    :key="user.id"
                    class="d-flex justify-content-between align-items-center mb-2 p-2"
                  >
                    <span>{{ user.name }}</span>
                    <input
                      type="checkbox"
                      v-model="selectedUsers"
                      :value="user.id"
                    />
                  </div>
                  <p v-if="users.length === 0" class="text-muted text-center">users
                    No users available
                  </p>
                </div>
              </div>

              <div class="col-md-8">
                <h4 class="mb-5">Transfer chat</h4>
                <textarea
                  class="form-control mb-3"
                  v-model="message"
                  placeholder="Type a message..."
                  rows="8"
                ></textarea>
                <div class="d-flex justify-content-between">
                  <button class="btn btn-secondary" @click="$emit('close')">
                    Cancel
                  </button>
                  <button
                    class="btn btn-primary"
                    :disabled="!canAccept"
                    @click="onAccept"
                  >
                    Transfer Chat
                  </button>
                </div>
              </div>

            </div>
          </div>
        </template>
      </portlet>

      <button class="close-btn" @click="$emit('close')">&times;</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import store from '../../../store.js'
import { RIGHTS } from '../../../views/roles/rights.js'

export default {
  name: 'TransferChatModal',
  props: {
    chatId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      users: [],
      selectedUsers: [],
      selectAll: false,
      message: ''
    }
  },
  computed: {
    canAccept() {
      return this.selectedUsers.length > 0
    }
  },
  watch: {
    selectedUsers(ids) {
      this.selectAll = ids.length === this.users.length
    },
    users(newUsers) {
      this.selectAll = this.selectedUsers.length === newUsers.length
    }
  },
  async created() {
    this.rights = RIGHTS;
    await store.dispatch('chats/getRellocateAvailability', { 
      ApiClient: Vue.prototype.$ApiClient, 
      departments: this.$store.getters.getUserData.departments,
      chatId: this.chatId
    }).then((res) => {
      if (res.status === 200) {
          this.users = res.data.data;
      }
    }).catch((err) => {

    });
  },
  methods: {
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedUsers = this.users.map(u => u.id)
      } else {
        this.selectedUsers = []
      }
    },
    onAccept() {
      this.$emit('confirmTransfer', {
        userIds: this.selectedUsers,
        message: this.message
      })
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
  .overlay {
    position: fixed;
    top:0; left:0;
    width:100%; height:100%;
    background: rgba(0,0,0,0.5);
    display:flex;
    align-items:center;
    justify-content:center;
    z-index:1050;
  }
  .modal-wrapper {
    position:relative;
    width: 800px;
    max-width: 95%;
    background: #fff;
  }
  .btn {
    border-radius: 10px;
  }
  .modal-wrapper .btn-primary {
    background-color: #FF924E;
    border: none;
  }
  .modal-wrapper .btn-secondary {
    background-color: #146F70;
    border: none;
  }
  .modal-wrapper .btn-primary:hover {
    background-color: #E58346;
  }
  .modal-wrapper .btn-secondary:hover {
    background-color: #126465;
  }
  .close-btn {
    position:absolute;
    top:1.5rem; 
    right:2rem;
    background:transparent;
    border:none;
    font-size:2.5rem;
    color:#333;
    cursor:pointer;
  }
  .user-list {
    max-height: 200px;
    overflow-y: auto;
  }
  ::v-deep .m-portlet__head {
    display: none
  }
</style>
